module.exports = __webpack_public_path__ + "static/media/MuseoSansDisplay-Black.feb3f487.ttf";